import { css, SerializedStyles } from '@emotion/core';

/* pass media css */
export const media = {
  largeScreen: (arg1: TemplateStringsArray, ...args: any): SerializedStyles =>
    css({
      '@media (min-width: 1400px)': css(arg1, ...args),
    }),
  /* pass media css */
  smallScreen: (arg1: TemplateStringsArray, ...args: any): SerializedStyles =>
    css({
      '@media (max-width: 600px)': css(arg1, ...args),
    }),
};
